var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStepQueryDefinition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0111 14.2222H15.8889L21.4333 19.7778L19.7778 21.4333L14.2222 15.8889V15.0111L13.9222 14.7C12.6556 15.7889 11.0111 16.4444 9.22222 16.4444C5.23333 16.4444 2 13.2111 2 9.22222C2 5.23333 5.23333 2 9.22222 2C13.2111 2 16.4444 5.23333 16.4444 9.22222C16.4444 11.0111 15.7889 12.6556 14.7 13.9222L15.0111 14.2222ZM4.22222 9.22222C4.22222 11.9889 6.45556 14.2222 9.22222 14.2222C11.9889 14.2222 14.2222 11.9889 14.2222 9.22222C14.2222 6.45556 11.9889 4.22222 9.22222 4.22222C6.45556 4.22222 4.22222 6.45556 4.22222 9.22222ZM6.44445 19.7778H4.22222V22H6.44445V19.7778ZM10.8889 19.7778H8.66667V22H10.8889V19.7778ZM15.3333 22V19.7778H13.1111V22H15.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStepQueryDefinition);
export default __webpack_public_path__ + "static/media/icon_step_query_definition.74b1dcffea75736d0458b603514bab3e.svg";
export { ForwardRef as ReactComponent };